import type { PropsWithChildren } from 'react';
import { createContext, useCallback, useContext, useState } from 'react';

type ApplicationUserData = {
  email: string;
  firstName?: string;
  lastName?: string;
  cvUploadId?: string;
  cvFileName?: string;
  cvStagedUploadId?: string;
  cvSelectionSource?: 'existing' | 'upload';
};

type SetApplicationUserData = (
  applicationUserData: ApplicationUserData
) => void;

const UpdateApplicationUserDataContext = createContext<SetApplicationUserData>(
  () => undefined
);
const ApplicationUserDataContext = createContext<
  ApplicationUserData | undefined
>(undefined);

export const ApplicationUserDataProvider: React.FC<
  PropsWithChildren<unknown>
> = ({ children }) => {
  const [userData, setUserData] = useState<ApplicationUserData | undefined>(
    undefined
  );

  const setApplicationUserDataValue = useCallback(
    (applicationUserData: ApplicationUserData): void => {
      setUserData(applicationUserData);
    },
    []
  );

  return (
    <UpdateApplicationUserDataContext.Provider
      value={setApplicationUserDataValue}
    >
      <ApplicationUserDataContext.Provider value={userData}>
        {children}
      </ApplicationUserDataContext.Provider>
    </UpdateApplicationUserDataContext.Provider>
  );
};

export const useSetApplicationUserData = (): SetApplicationUserData => {
  return useContext(UpdateApplicationUserDataContext);
};

export const useApplicationUserData = (): ApplicationUserData | undefined => {
  return useContext(ApplicationUserDataContext);
};
